import { useState } from "react";

type Item = { q: string; a: string };

type Props = {
  items: Item[];
  defaultOpen?: number | null;
};

export default function FaqAccordion({ items, defaultOpen = 0 }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="overflow-hidden rounded-lg border border-background-300 bg-background-100">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q} className="border-b border-background-200 last:border-b-0">
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer transition-colors hover:bg-background-200/60"
            >
              <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                {item.q}
              </span>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500">
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-5">
                <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}